module.exports = __webpack_public_path__ + "static/media/linecons.a7f0b3b4.woff";


//////////////////
// WEBPACK FOOTER
// ./src/CSS/assets-minified/icons/linecons/linecons.woff
// module id = ./src/CSS/assets-minified/icons/linecons/linecons.woff
// module chunks = 0